import Add from '@mui/icons-material/Add'
import AttachMoney from '@mui/icons-material/AttachMoney'
import BarChart from '@mui/icons-material/BarChart'
import Bolt from '@mui/icons-material/Bolt'
import Bookmark from '@mui/icons-material/Bookmark'
import Build from '@mui/icons-material/Build'
import CalendarMonth from '@mui/icons-material/CalendarMonth'
import Chat from '@mui/icons-material/Chat'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutlineOutlined'
import Close from '@mui/icons-material/Close'
import CloudDownload from '@mui/icons-material/CloudDownload'
import CloudUpload from '@mui/icons-material/CloudUpload'
import Code from '@mui/icons-material/Code'
import ContentCopy from '@mui/icons-material/ContentCopy'
import ContentCut from '@mui/icons-material/ContentCut'
import Delete from '@mui/icons-material/Delete'
import Description from '@mui/icons-material/Description'
import Done from '@mui/icons-material/Done'
import Edit from '@mui/icons-material/Edit'
import Email from '@mui/icons-material/Email'
import ErrorOutline from '@mui/icons-material/ErrorOutlineOutlined'
import Favorite from '@mui/icons-material/Favorite'
import FavoriteBorder from '@mui/icons-material/FavoriteBorder'
import Filter from '@mui/icons-material/Filter'
import Folder from '@mui/icons-material/Folder'
import Forum from '@mui/icons-material/Forum'
import Group from '@mui/icons-material/Group'
import Image from '@mui/icons-material/Image'
import Info from '@mui/icons-material/Info'
import Inventory from '@mui/icons-material/Inventory'
import Lightbulb from '@mui/icons-material/Lightbulb'
import Lock from '@mui/icons-material/Lock'
import LockOpen from '@mui/icons-material/LockOpen'
import MapIcon from '@mui/icons-material/Map'
import Memory from '@mui/icons-material/Memory'
import Person from '@mui/icons-material/Person'
import Phone from '@mui/icons-material/Phone'
import PieChart from '@mui/icons-material/PieChart'
import Place from '@mui/icons-material/Place'
import Public from '@mui/icons-material/Public'
import Receipt from '@mui/icons-material/Receipt'
import Remove from '@mui/icons-material/Remove'
import Reply from '@mui/icons-material/Reply'
import RocketLaunch from '@mui/icons-material/RocketLaunch'
import Save from '@mui/icons-material/Save'
import Schedule from '@mui/icons-material/Schedule'
import Search from '@mui/icons-material/Search'
import Security from '@mui/icons-material/Security'
import Send from '@mui/icons-material/Send'
import Settings from '@mui/icons-material/Settings'
import Share from '@mui/icons-material/Share'
import Shield from '@mui/icons-material/Shield'
import ShoppingCart from '@mui/icons-material/ShoppingCart'
import ShowChart from '@mui/icons-material/ShowChart'
import Star from '@mui/icons-material/Star'
import StarBorder from '@mui/icons-material/StarBorder'
import Storage from '@mui/icons-material/Storage'
import TrendingDown from '@mui/icons-material/TrendingDown'
import TrendingUp from '@mui/icons-material/TrendingUp'
import Tune from '@mui/icons-material/Tune'
import Verified from '@mui/icons-material/Verified'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import WarningAmber from '@mui/icons-material/WarningAmber'

type SvgIconComponent = typeof Star

export type IconLibraryEntry = { name: string; component: SvgIconComponent; category: string }

export const ICON_LIBRARY: IconLibraryEntry[] = [
  { name: 'Star', component: Star, category: 'Symbols' },
  { name: 'StarBorder', component: StarBorder, category: 'Symbols' },
  { name: 'FavoriteBorder', component: FavoriteBorder, category: 'Symbols' },
  { name: 'Favorite', component: Favorite, category: 'Symbols' },
  { name: 'CheckCircleOutline', component: CheckCircleOutline, category: 'Status' },
  { name: 'ErrorOutline', component: ErrorOutline, category: 'Status' },
  { name: 'WarningAmber', component: WarningAmber, category: 'Status' },
  { name: 'Info', component: Info, category: 'Status' },
  { name: 'Bolt', component: Bolt, category: 'Status' },
  { name: 'Lightbulb', component: Lightbulb, category: 'Status' },
  { name: 'RocketLaunch', component: RocketLaunch, category: 'Status' },
  { name: 'Settings', component: Settings, category: 'System' },
  { name: 'Tune', component: Tune, category: 'System' },
  { name: 'Person', component: Person, category: 'People' },
  { name: 'Group', component: Group, category: 'People' },
  { name: 'Email', component: Email, category: 'Comms' },
  { name: 'Phone', component: Phone, category: 'Comms' },
  { name: 'Public', component: Public, category: 'Comms' },
  { name: 'Schedule', component: Schedule, category: 'Time' },
  { name: 'CalendarMonth', component: CalendarMonth, category: 'Time' },
  { name: 'CloudUpload', component: CloudUpload, category: 'Data' },
  { name: 'CloudDownload', component: CloudDownload, category: 'Data' },
  { name: 'Save', component: Save, category: 'Data' },
  { name: 'Folder', component: Folder, category: 'Data' },
  { name: 'Description', component: Description, category: 'Data' },
  { name: 'Image', component: Image, category: 'Data' },
  { name: 'Map', component: MapIcon, category: 'Map' },
  { name: 'Place', component: Place, category: 'Map' },
  { name: 'Search', component: Search, category: 'Action' },
  { name: 'Filter', component: Filter, category: 'Action' },
  { name: 'Bookmark', component: Bookmark, category: 'Action' },
  { name: 'Share', component: Share, category: 'Action' },
  { name: 'Send', component: Send, category: 'Action' },
  { name: 'Reply', component: Reply, category: 'Action' },
  { name: 'Chat', component: Chat, category: 'Comms' },
  { name: 'Forum', component: Forum, category: 'Comms' },
  { name: 'Edit', component: Edit, category: 'Editing' },
  { name: 'Delete', component: Delete, category: 'Editing' },
  { name: 'ContentCopy', component: ContentCopy, category: 'Editing' },
  { name: 'ContentCut', component: ContentCut, category: 'Editing' },
  { name: 'Add', component: Add, category: 'Editing' },
  { name: 'Remove', component: Remove, category: 'Editing' },
  { name: 'Close', component: Close, category: 'Editing' },
  { name: 'Done', component: Done, category: 'Editing' },
  { name: 'Lock', component: Lock, category: 'Security' },
  { name: 'LockOpen', component: LockOpen, category: 'Security' },
  { name: 'Visibility', component: Visibility, category: 'Security' },
  { name: 'VisibilityOff', component: VisibilityOff, category: 'Security' },
  { name: 'TrendingUp', component: TrendingUp, category: 'Charts' },
  { name: 'TrendingDown', component: TrendingDown, category: 'Charts' },
  { name: 'PieChart', component: PieChart, category: 'Charts' },
  { name: 'BarChart', component: BarChart, category: 'Charts' },
  { name: 'ShowChart', component: ShowChart, category: 'Charts' },
  { name: 'Code', component: Code, category: 'Tech' },
  { name: 'Storage', component: Storage, category: 'Tech' },
  { name: 'Memory', component: Memory, category: 'Tech' },
  { name: 'Build', component: Build, category: 'Tech' },
  { name: 'Inventory', component: Inventory, category: 'Commerce' },
  { name: 'ShoppingCart', component: ShoppingCart, category: 'Commerce' },
  { name: 'AttachMoney', component: AttachMoney, category: 'Commerce' },
  { name: 'Receipt', component: Receipt, category: 'Commerce' },
  { name: 'Verified', component: Verified, category: 'Security' },
  { name: 'Shield', component: Shield, category: 'Security' },
  { name: 'Security', component: Security, category: 'Security' },
]

export const ICON_BY_NAME: Map<string, SvgIconComponent> = new Map(ICON_LIBRARY.map((i) => [i.name, i.component]))

export const ICON_CATEGORIES: string[] = Array.from(new Set(ICON_LIBRARY.map((i) => i.category)))
